/**
 * The user types that may exist in the system (besides anonymous users in the homepage)
 */
export enum UserType {
  Admin = 'admin',
  Agent = 'agent',
  Candidate = 'candidate',
}
